import React, { useEffect, useState } from "react";
import { Home, MapPin, Star, Image, Info, Eye, Headphones } from "lucide-react";

const steps = [
  {
    id: "basic-details",
    number: 1,
    title: "Basic Details",
    subtitle: "Room info & rent",
    icon: Home,
  },
  {
    id: "location",
    number: 2,
    title: "Location",
    subtitle: "Where is it located?",
    icon: MapPin,
  },
  {
    id: "amenities",
    number: 3,
    title: "Amenities",
    subtitle: "Facilities & features",
    icon: Star,
  },
  {
    id: "photos",
    number: 4,
    title: "Photos & Video",
    subtitle: "Show your room",
    icon: Image,
  },
  {
    id: "additional",
    number: 5,
    title: "Additional Info",
    subtitle: "Rules & details",
    icon: Info,
  },
  // {
  //   id: "preview",
  //   number: 6,
  //   title: "Preview",
  //   subtitle: "Review & publish",
  //   icon: Eye,
  // },
];

export default function ListingSidebar() {
  const [currentStep, setCurrentStep] = useState("basic-details");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.find((e) => e.isIntersecting);

        if (visible) {
          setCurrentStep(visible.target.id);
        }
      },
      {
        threshold: 0.35,
      },
    );

    steps.forEach((step) => {
      const element = document.getElementById(step.id);

      if (element) observer.observe(element);
    });

    return () => observer.disconnect();
  }, []);

  return (
    // <div className="sticky top-24">
    // <div className="sticky top-28 self-start">
    <div className="h-fit">
      <div className="bg-white rounded-3xl border shadow-sm p-8">
        <div className="space-y-8">
          {steps.map((step, index) => {
            const Icon = step.icon;

            const active = currentStep === step.id;

            const completed =
              steps.findIndex((s) => s.id === currentStep) > index;

            return (
              <div key={step.id} className="relative flex gap-4">
                {index !== steps.length - 1 && (
                  <div
                    className={`absolute left-5 top-10 h-16 w-[2px]

                    ${completed ? "bg-orange-500" : "bg-gray-200"}`}
                  />
                )}

                <div
                  className={`relative z-10 w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold

                  ${
                    active
                      ? "bg-orange-500 text-white"
                      : completed
                        ? "bg-orange-100 text-orange-600"
                        : "bg-gray-100 text-gray-600"
                  }`}
                >
                  {step.number}
                </div>

                <div>
                  <div className="flex items-center gap-2">
                    <Icon
                      size={16}
                      className={
                        active
                          ? "text-orange-500"
                          : completed
                            ? "text-orange-400"
                            : "text-gray-400"
                      }
                    />

                    <h3
                      className={`font-semibold

                      ${
                        active
                          ? "text-orange-500"
                          : completed
                            ? "text-orange-400"
                            : "text-gray-900"
                      }`}
                    >
                      {step.title}
                    </h3>
                  </div>

                  <p className="text-sm text-gray-500 mt-1">{step.subtitle}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Help Card */}

      <div className="bg-orange-50 rounded-3xl p-2 mt-6">
        <Headphones className="text-orange-500" size={32} />

        <h3 className="font-bold mt-4">Need Help?</h3>

        <p className="text-sm text-gray-600 mt-2">
          Our support team is always here for you.
        </p>

        <div className="mt-3">
          <p className="text-sm text-gray-500">Call us</p>
          <a
            href="tel:+9779800000000"
            className="text-lg font-semibold text-orange-600 hover:underline"
          >
            +977 970-8919809
          </a>
        </div>

        <a
          href="tel:+977 970-8919809"
          className="block w-full mt-5 bg-orange-500 text-white text-center rounded-xl py-3 hover:bg-orange-600 transition"
        >
          Contact Support
        </a>
      </div>
    </div>
  );
}
